import { APICore } from './apiCore';

const api = new APICore();

interface BroadcastData {
    broadcast_name: string;
    template_id: string;
    type: string;
    contacts: string[];
    schedule_date?: string | null;
    schedule_time?: string | null;
}


export function CreateBroadcast(broadcastData: BroadcastData) {
    const baseUrl = '/broadcasts';
    return api.create(baseUrl, broadcastData);
}

export function GroupContacts(){
    const baseUrl ='/GroupContact';
    return api.show(baseUrl);
}
export function getBroadcasts(){
    const baseUrl ='/broadcasts';
    return api.show(baseUrl);
}

export function showDate(from_date: string, to_date: string) {
    return api.create('/broadcasts/showdate', {
        from_date,
        to_date
    });
}


export function getBroadcastContacts(broadcast_id: string) {
    return api.get(`/broadcasts/${broadcast_id}/contacts`);
}


